import * as R from 'ramda'

export function parseIfExisting(envVariable) {
  if (R.not(R.isEmpty(envVariable)) && R.not(R.isNil(envVariable))) {
    return JSON.parse(envVariable)
  } else {
    return envVariable
  }
}
